import { useTranslation } from 'react-i18next';
import { PurchaseOrderStatus } from '@optiflow/types';
import { Badge } from '@/components/ui/Badge';

type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'brand';

/**
 * What a purchase order's state looks like, decided once.
 *
 * A draft is quiet because it commits nothing; an order waiting on a supplier is the one a buyer
 * is chasing, so it carries the brand colour. Received is the happy ending, closed is the one
 * where part of it never came, and cancelled is the one nothing came against.
 */
const TONES: Record<PurchaseOrderStatus, Tone> = {
  [PurchaseOrderStatus.DRAFT]: 'neutral',
  [PurchaseOrderStatus.ORDERED]: 'brand',
  [PurchaseOrderStatus.PARTIALLY_RECEIVED]: 'warning',
  [PurchaseOrderStatus.RECEIVED]: 'success',
  [PurchaseOrderStatus.CLOSED]: 'neutral',
  [PurchaseOrderStatus.CANCELLED]: 'danger',
};

export function PurchaseOrderStatusBadge({ status }: { status: PurchaseOrderStatus }) {
  const { t } = useTranslation();

  return <Badge tone={TONES[status] ?? 'neutral'}>{t(`purchasing.orders.status.${status}`)}</Badge>;
}
